
        var result = require("!!../../../../node_modules/css-loader/index.js!./article-discount.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/article-discount.component.css
// module id = 2325
// module chunks = 1